import { observer } from "mobx-react-lite";
import { Button, Icon, Table } from "semantic-ui-react";
import {
  formatCurrency,
} from "../../app/common/util/functions";
import { useEffect, useState } from "react";
import { useStore } from "../../app/stores/store";
import { useTranslation } from "react-i18next";
import PartTicketSearch from "./PartTicketSearch";

interface Props {
  loadExpandedDetails?: () => Promise<void>;
}

export default observer(function PartDetailsSearch(
  {loadExpandedDetails} : Props
) {
  const { t } = useTranslation(["common", "search"]);

  const [expand, setExpand] = useState<boolean>(false);

  const handleExpand = () => {
    setExpand(!expand);
  };


  const { inventoryIndexStore } = useStore();
  const { expandedInventoryIndexItemVendor, expandedInventoryIndexItem, loadExpandedInventoryIndexItemTickets } = inventoryIndexStore;

  useEffect(() => {
    loadExpandedInventoryIndexItemTickets(expandedInventoryIndexItem?.partId ?? "")
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expandedInventoryIndexItem, expand]);

  return (
    <Table.Cell className="tableInTable textAlignRightNotMobile" colSpan={8}>
      <Table striped unstackable className="dnxTable no_padding">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>
              {t("vendors.vendor", { ns: "miscSettings" })}
            </Table.HeaderCell>
            <Table.HeaderCell>{t("Unit Cost", { ns: "common" })}</Table.HeaderCell>
            <Table.HeaderCell>
              {t("Markup %", { ns: "common" })}
            </Table.HeaderCell>
            <Table.HeaderCell>
              {t("Quantity in Stock", { ns: "common" })}
            </Table.HeaderCell>
            <Table.HeaderCell>
              {t("Core Tracking", { ns: "common" })}
            </Table.HeaderCell>
            <Table.HeaderCell>{t("Notes", { ns: "common" })}</Table.HeaderCell>
            <Table.HeaderCell></Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <Table.Row key={""}>
            <Table.Cell data-label={`${t("description", { ns: "common" })}:`}>
              {expandedInventoryIndexItemVendor?.vendorName ? expandedInventoryIndexItemVendor?.vendorName : "No Vendor Assigned"}
            </Table.Cell>
            <Table.Cell data-label={`${t("date", { ns: "common" })}:`}>
              {formatCurrency(expandedInventoryIndexItemVendor?.cost!)}
            </Table.Cell>
            <Table.Cell data-label={`${t("ticket", { ns: "common" })}:`}>
              {expandedInventoryIndexItemVendor?.markup!}%
            </Table.Cell>
            <Table.Cell data-label={`${t("po", { ns: "common" })}#:`}>
              {expandedInventoryIndexItemVendor?.quantityInStock}
            </Table.Cell>
            <Table.Cell data-label={`${t("total", { ns: "common" })}:`}>
              {expandedInventoryIndexItemVendor?.coreTracking ? <Icon name="check" color="green" size="big" /> : null}
            </Table.Cell>
            <Table.Cell className="textAlignRight" width={6}>
              <Button
                content={t("Previous Tickets", { ns: "common" })}
                icon="plus square"
                size="small"
                className="tealishButtons"
                onClick={handleExpand}
              />
              {/*
              <Button
                className="save_button mobile_buttons"
                size="mini"
                icon="edit"
                content={t("Edit", { ns: "common" })}
                onClick={() => { }}
              />

              <Button
                content={t("more", { ns: "recentTickets" })}
                icon="plus"
                size="mini"
                onClick={() => {
                  navigate(`/customer`);
                }}
              /> */}
            </Table.Cell>
          </Table.Row>
          {/* ))
          ) : (
            <Table.Row key={"noItems"}>
              <Table.Cell width="8" colSpan={8}  className="noPaddingLeft">
                <Message
                  color="yellow"
                  className="textAlignCenter fontStyleItalic"
                >
                  {t("grid_noItems", { ns: "common" })}
                </Message>
              </Table.Cell>
            </Table.Row>
          )} */}
          {expand && <PartTicketSearch />}
        </Table.Body>
      </Table>
    </Table.Cell>
  );
});
